// Import sites core css
// This will be handled by webpack and injected into the html served
import 'sass/main.scss'

// toastr styles
import 'css/animate.min.css'
import 'css/toastr.min.css'

// React
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import createHistory from 'history/createBrowserHistory'
import isFeatureEnabled from './utils/features'
import api from './utils/api'

// Authentication
import azureInit, { redirectToLogin, getToken, clearToken } from 'colleague-auth'

// Components
import HeaderComponent from './components/Header'
import Home from './components/Home'
import Employer from './components/Employer'
import Contractor from './components/Contractor'
import ConsentAdmin from './components/ConsentAdmin'
import FireRollCall from './components/FireRollCall'
import ContractedHours from './components/ContractedHours'
import Reporting from './components/Reporting/index'
import ReportViewer from './components/ReportViewer/index'
import Passes from './components/Passes'
import config from './utils/config'
import { getPathname } from './utils/common'
import { hasTokenExpired } from './utils/token'
import PassDetails from './components/Passes/PassDetails'

// Import redux store builder
import configureStore from './store/configureStore'
import userActions from './store/user/actions'

// Import Google Analytics
// import ReactGA from 'react-ga4'

// ReactGA.initialize("G-JLJV55HVE4")

const currentURL = window.location.href

// Configure store, it uses connected-react-router under the hood to hook up rooting changes
const history = createHistory()
const store = configureStore(history)

// Get the root element to bootstrap the app into
const mountElement = document.getElementById('root')
const Console = console

// Log the initial state
//Console.log(store.getState())

// Every time the state changes, log it
// Note that subscribe() returns a function for unregistering the listener
//store.subscribe(() => Console.log(store.getState()))

azureInit({
  clientId: config.getClientId(),
  redirectUri: config.getApplicationUrl()
})

if (currentURL.toLowerCase().includes('firerollcall') && 
  !window.location.href.toLowerCase().includes('firerollcall')) {
    window.location.href = `${config.getApplicationUrl()}/firerollcall`
}

const token = getToken()
const isConsentAdminPath = () => {
  const pathname = getPathname()
  return pathname.indexOf('consentadmin') !== -1
}

const getPassesRoutes = (features) => {
  // protect with colleague service in future too, but for now just feature flag
  if (isFeatureEnabled(features, 'Passes')) {
    return (
      <div>
        <Route path="/passes/passDetails" exact component={() => <PassDetails />} />       
        <Route path="/passes" exact component={() => <Passes setMenu />} />
      </div>
    )
  }

  return null
}

const getAuthenticatedRoutes = (permissions, features) => {
  if (permissions.canViewCompanies) {
    return (
      <div>
        <HeaderComponent />
        <Switch>
          <Route path="/" exact component={() => <Home isExternalUser={permissions.isExternalUser} />} />
          <Route path="/employers" exact component={() => <Home isExternalUser={permissions.isExternalUser} />} />
          <Route path="/employers/add" exact component={() => <Employer isExternalUser={permissions.isExternalUser} isDirty />} />
          <Route path="/employers/:employerId/contractors/add" exact component={() => <Contractor isDirty />} />
          <Route path="/employers/:employerId/contractors/:contractorId" component={() => <Contractor isDirty={false} />} />
          <Route path="/employers/:employerId" component={() => <Employer isDirty={false} />} />
          {permissions.canViewFireRollCall && <Route path="/firerollcall/" component={() => <FireRollCall setMenu />} />}
          {
            permissions.canViewContractedHours && <Route path="/contractedhours" component={() => <ContractedHours setMenu />} />
          }
          <Route path="/reporting" component={() => <Reporting setMenu />} />
          <Route path="/reportviewer" component={() => <ReportViewer />} />
          {getPassesRoutes(features)}
          <Route component={() => <span>Not Found!</span>} />
        </Switch>
      </div>
    )
  }
  return (
    <div>
      <HeaderComponent />
      <Switch>
        {permissions.canViewFireRollCall && <Route path="/" exact component={() => <FireRollCall setMenu />} />}
        {permissions.canViewFireRollCall && <Route path="/firerollcall/" component={() => <FireRollCall setMenu />} />}
        {getPassesRoutes(features)}
        <Route component={() => <span>Not Found!</span>} />
      </Switch>
    </div>
  )
}

const getUnauthenticatesRoutes = () => (
  <Switch>
    <Route path="/consentadmin" component={() => <ConsentAdmin />} />
  </Switch>
)

const getRoutes = (permissions, features) => {
  if (token) {
    return getAuthenticatedRoutes(permissions, features)
  } else if (isConsentAdminPath()) {
    return getUnauthenticatesRoutes()
  }
  return <div />
}

if ((token && !hasTokenExpired()) || isConsentAdminPath()) {
  api.getPermissions()
    .then(async (permissions) => {
      const features = await api.getFeatures()
      api.getUser()
        .then(user => store.dispatch({ type: userActions.set, user }))
        .catch(() => store.dispatch({ type: userActions.set, user: null }))

      // Finally render :)
      // Provider is a part of react-redux that injects the required state parts into container components
      sessionStorage.setItem('logoutUrl', `${config.getLogoutUrl()}${window.location.origin}`)
      ReactDOM.render(
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <div>
              {getRoutes(permissions, features)}
            </div>
          </ConnectedRouter>
        </Provider>,
        mountElement
      )
    })
} else {
  clearToken()
  if (currentURL.toLowerCase().includes('firerollcall')) {
    redirectToLogin({ redirectUri: currentURL })
  }
  else {
    redirectToLogin()
  }
}


// WEBPACK FOOTER //
// ./src/index.jsx